export default "__VITE_ASSET__BdHO$bJc__"